import { gql } from '@apollo/client'

import { SIMPLE_USER_FRAGMENT } from '../../../common/graphql/fragments'

const UNKNOWN_WORD_LIST_FRAGMENT = gql`
  fragment UnknownWordListFragment on UnknownWord {
    id
    menuCurationTaskId
    value
    originalValue
    context
    payload
    initialPayload
    translation
    labelLegendMatchType
    originField
    type
    dietId
    allergenId
    ingredientId
    languageId
    ingredientKeywordMatchType
    posIndex
    menuTitle {
      id
      title
      isDeleted
    }
    dish {
      id
      name
      isDeleted
    }
    correction {
      value
      type
      ingredientKeywordMatchType
      languageId
      allergenId
      dietId
      ingredientId
    }
    isContextDependantFromAi
    isContextDependant
    isExported
    isCurationDone
    isQaDone
    updatedBy {
      ...SimpleUserFragment
    }
    updatedAt
    createdBy {
      ...SimpleUserFragment
    }
    createdAt
    curatedBy {
      ...SimpleUserFragment
    }
    curatedAt
    qadBy {
      ...SimpleUserFragment
    }
    qadAt
  }
  ${SIMPLE_USER_FRAGMENT}
`

export default UNKNOWN_WORD_LIST_FRAGMENT
